export class CurrentUserModel {
    UserId: string = '';
    UserPermissions: any = {};
    KioskPermissions: string[] = [];

    constructor() { }
}